import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CollapseModule } from 'shared/collapse/collapse.module';
import { BadgeModule } from 'shared/badge/badge.module';
import { AppTooltipModule } from 'shared/tooltip/tooltip.module';
import { IconModule } from 'shared/icon/icon.module';

import { ScorecardService } from 'shared/scorecard/scorecard.service';
import { ScorecardConnectorService } from 'shared/scorecard/scorecard-connector.service';

import { ScoreComponent } from './score/score.component';
import { ScorecardComponent } from './scorecard/scorecard.component';
import { ScorecardItemComponent } from './scorecard-item/scorecard-item.component';
import { ScorecardItemHeaderComponent } from './scorecard-item-header/scorecard-item-header.component';
import { ScorecardDetailsComponent } from './scorecard-details/scorecard-details.component';
import { IncompatibleScorecardComponent } from './incompatible-scorecard/incompatible-scorecard.component';


@NgModule({
    imports: [
        CommonModule,
        CollapseModule,
        BadgeModule,
        AppTooltipModule,
        IconModule,
    ],
    declarations: [
        ScoreComponent,
        ScorecardComponent,
        ScorecardItemComponent,
        ScorecardItemHeaderComponent,
        ScorecardDetailsComponent,
        IncompatibleScorecardComponent,
    ],
    exports: [
        ScoreComponent,
        ScorecardComponent,
        ScorecardItemComponent,
        ScorecardItemHeaderComponent,
        ScorecardDetailsComponent,
        IncompatibleScorecardComponent,
    ],
    providers: [
        ScorecardService,
        ScorecardConnectorService,
    ]
})
export class ScorecardModule {}
